var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SalesDashboardCard",
    {
      attrs: {
        title: "Books (tags)",
        "class-card": "col-md-4",
        "selected-filter": _vm.selectedFilter,
        filters: _vm.filters
      },
      on: { "set-filter": _vm.setFilter }
    },
    [
      _c(
        "div",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _vm.loading
            ? _c("Loader")
            : _vm.tags && _vm.tags.length > 0
              ? _c("div", { staticClass: "d-flex justify-content-between" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column pr-1" },
                    _vm._l(
                      _vm.tags.slice(0, parseInt(_vm.tags.length / 2)),
                      function(tag, i) {
                        return _c(
                          "div",
                          {
                            key: i,
                            staticClass:
                              "d-flex align-items-center justify-content-between"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c("span", {
                                  staticClass: "tag-color",
                                  style: { "background-color": tag.tag_color }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "tag-name" }, [
                                  _vm._v(_vm._s(tag.tag_name))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "d-inline-block ml-2" }, [
                              _vm._v(_vm._s(tag.count_jobs))
                            ])
                          ]
                        )
                      }
                    )
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column pr-1" },
                    _vm._l(
                      _vm.tags.slice(
                        parseInt(_vm.tags.length / 2),
                        _vm.tags.length
                      ),
                      function(tag, i) {
                        return _c(
                          "div",
                          {
                            key: i,
                            staticClass:
                              "d-flex align-items-center justify-content-between"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c("span", {
                                  staticClass: "tag-color",
                                  style: { "background-color": tag.tag_color }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "tag-name" }, [
                                  _vm._v(_vm._s(tag.tag_name))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "d-inline-block ml-2" }, [
                              _vm._v(_vm._s(tag.count_jobs))
                            ])
                          ]
                        )
                      }
                    )
                  )
                ])
              : _c("div", [
                  _c("p", { staticClass: "text-center" }, [
                    _vm._v("There are no jobs.")
                  ])
                ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fcb8b22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fcb8b22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/salesDashboard/subcomponents/cards/BooksTags.vue
// module id = null
// module chunks = 